<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
        <h3 class="p-2">
            <small class="text-muted">Patient Detail</small>
            <button v-if="this.patientMedicalRecordId != '' && this.role != 'staff'" type="button" class="btn btn-outline-primary" style="margin-left: 20px; float: right;" @click="medicalHistory">Medical History <i class="fas fa-first-aid"></i></button>
            <button v-if="this.patientOrthoSpaceId != '' && this.role != 'staff'" type="button" class="btn btn-outline-primary" style="margin-left: 20px; float: right;" @click="orthoSpace">Ortho Space <i class="fas fa-notes-medical"></i></button>
            <button v-if="this.patientOrthoDiagnoseId != '' && this.role != 'staff'" type="button" class="btn btn-outline-primary" style="margin-left: 20px; float: right;" @click="orthoDiagnose">Ortho Diagnose <i class="fas fa-notes-medical"></i></button>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-3">
                <label>Patient Name</label>
                <input type="text" class="form-control" v-model="patient.name" id="name" aria-describedby="patient-name">
            </div>
            <div class="form-group col-2">
                <label>QQ</label>
                <input type="text" class="form-control" v-model="patient.qq" id="qq" aria-describedby="qq">
            </div>
            <div class="form-group col-1">
                <label for="role">Gender</label>
                <app-dropdown :id="'gender'" :keyName="'gender'" :model="patient.gender" :lists="genderList" :title="'name'" :value="'id'" v-on:selectedChanged="selectChange"></app-dropdown>
            </div>
            <div class="form-group col-2">
                <label for="date">Date Of Birth</label>
                <flat-pickr style="background-color:white;" class="form-control" id="btk-purchase-date" v-model="patient.dateOfBirth"></flat-pickr>
            </div>
            <div class="form-group col-2">
                <label for="date">Place Of Birth</label>
                <input type="text" class="form-control" v-model="patient.placeOfBirth" id="name" aria-describedby="placeOfBirth">
            </div>
            <div class="form-group col-2">
                <label for="date">Phone Number</label>
                <input type="text" class="form-control" v-model="patient.cellPhone" id="name" aria-describedby="phone">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-2">
                <label for="date">Religion</label>
                <app-dropdown :id="'religion'" :keyName="'religion'" :model="patient.religion" :lists="religionList" :title="'name'" :value="'id'" v-on:selectedChanged="selectChange"></app-dropdown>
            </div>
            <div class="form-group col-2">
                <label>Height</label>
                <input type="text" class="form-control" v-model="patient.height" id="name" aria-describedby="height">
            </div>
            <div class="form-group col-2">
                <label>Weight</label>
                <input type="text" class="form-control" v-model="patient.weight" id="name" aria-describedby="weight">
            </div>
            <div class="form-group col-2">
                <label>Blood Pressure</label>
                <input type="text" class="form-control" v-model="patient.bloodPressure" id="name" aria-describedby="blood-pressure">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-6">
                <label for="module">Address</label>
                <textarea class="form-control" id="desc-textarea" v-model="patient.address" rows="2"></textarea>
            </div>
            <div class="form-group col-6">
                <label for="module">Occupation</label>
                <textarea class="form-control" id="desc-textarea" v-model="patient.occupation" rows="2"></textarea>
            </div>
        </div>
        <!-- <div class="row">
            <div class="form-group col-3">
                <label for="module">Province</label>
                <app-lookup-field :model="patient" :element="provinceLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
            </div>
            <div class="form-group col-3">
                <label for="module">Regencies</label>
                <app-lookup-field :model="patient" :element="regenciesLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
            </div>
            <div class="form-group col-3">
                <label for="module">District</label>
                <app-lookup-field :model="patient" :element="districtLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
            </div>
            <div class="form-group col-3">
                <label for="module">Village</label>
                <app-lookup-field :model="patient" :element="villageLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
            </div>
        </div> -->
        <div id="borderline"></div>
        <br />
        <div class="row">
            <div class="form-group col-12">
                <label for="module">Allergy</label>
                <textarea class="form-control" id="desc-textarea" v-model="patient.allergy" rows="2"></textarea>
            </div>
        </div>
        <!-- <div class="row">
            <div class="form-group col-3">
                <label for="module">Treatment</label>
                <app-lookup-field :model="patient" :element="treatmentLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
            </div>
            <div v-if="patient.treatmentName === 'Other'" class="form-group col-6">
                <label for="module">Treatment Other</label>
                <input v-if="patient.treatmentName === 'Other'" type="text" v-model="patient.otherTreatment" class="form-control" placeholder="Please fill the other treatment" required>
            </div>
        </div> -->
        <div class="row">
            <div class="form-group col-6">
                <label for="module"><b>Patient Disease Hstory</b></label>
                <app-datatable :type="'input'" :newData="patientDiseaseHistory" :elements="dtElementsDisease" :collections="patient.patientDiseaseHistory"></app-datatable>
            </div>
            <div class="form-group col-6">
                <label for="module"><b>Patient Medication Hstory</b></label>
                <app-datatable :type="'input'" :newData="patientMedicationHistory" :elements="dtElementsMedication" :collections="patient.patientMedicationHistory"></app-datatable>
            </div>
        </div>
        <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-danger" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { Patient, PatientDiseaseHistory, PatientMedicationHistory } from '../../models/patient'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppDropdown from '../../components/AppDropdown.vue'
import AppNavBar from '../../components/AppNavbar.vue'

export default {
    components: {
        AppLookupField, AppDatatable, AppDatePicker, AppDropdown, AppNavBar
    },
    data() {
        return {
            patient: {
                ...Patient,
                patientDiseaseHistory: [],
                patientMedicationHistory: [],
            },
            patientMedicalRecordId: '',
            patientOrthoSpaceId: '',
            patientOrthoDiagnoseId: '',
            role: '',
            patientDiseaseHistory: PatientDiseaseHistory,
            patientMedicationHistory: PatientMedicationHistory,
            genderList: [],
            religionList: [],
            treatmentLookup: {
                id: 'treatment',
                title: 'Treatment',
                type: 'form',
                apiUrl: 'treatment-list',
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Treatment',
                        width: 12,
                        column: 'treatmentName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Treatment Name',
                        column: 'name'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'treatmentId'
                    },
                    {
                        from: 'name',
                        to: 'treatmentName'
                    }
                ]
            },
            provinceLookup: {
                id: 'province',
                title: 'Province',
                type: 'form',
                apiUrl: 'province-list',
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Province',
                        width: 12,
                        column: 'provinceName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Province Name',
                        column: 'name'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'provinceId'
                    },
                    {
                        from: 'name',
                        to: 'provinceName'
                    }
                ]
            },
            regenciesLookup: {
                id: 'regencies',
                title: 'Regencies',
                byParams: true,
                type: 'form',
                params: [
                    {
                        key: 'provinceId',
                        value: 'provinceId'
                    }
                ],
                apiUrl: `regencies-list`,
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Regencies',
                        width: 12,
                        column: 'regenciesName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Regencies Name',
                        column: 'name'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'regenciesId'
                    },
                    {
                        from: 'name',
                        to: 'regenciesName'
                    }
                ]
            },
            districtLookup: {
                id: 'district',
                title: 'District',
                byParams: true,
                type: 'form',
                params: [
                    {
                        key: 'regenciesId',
                        value: 'regenciesId'
                    }
                ],
                apiUrl: `district-list`,
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'District',
                        width: 12,
                        column: 'districtName'
                    }
                ],
                dtElements: [
                    {
                        title: 'District Name',
                        column: 'name'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'districtId'
                    },
                    {
                        from: 'name',
                        to: 'districtName'
                    }
                ]
            },
            villageLookup: {
                id: 'village',
                title: 'Village',
                byParams: true,
                type: 'form',
                params: [
                    {
                        key: 'districtId',
                        value: 'districtId'
                    }
                ],
                apiUrl: `village-list`,
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Village',
                        width: 12,
                        column: 'villageName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Village Name',
                        column: 'name'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'villageId'
                    },
                    {
                        from: 'name',
                        to: 'villageName'
                    }
                ]
            },
            dtElementsDisease: [
                {
                    title: 'Disease Name',
                    column: 'name',
                    type: 'text',
                    width: 4,
                },
                {
                    title: 'Remarks',
                    column: 'remarks',
                    type: 'text',
                    width: 4,
                },
            ],
            dtElementsMedication: [
                {
                    title: 'Medication Name',
                    column: 'name',
                    type: 'text',
                    width: 4,
                },
                {
                    title: 'Remarks',
                    column: 'remarks',
                    type: 'text',
                    width: 4,
                },
            ],
        }
    },
    computed: {
        getProvinceId() {
            return '0fecf56a-fbd5-4f9c-ae15-b59cb6a277ee';
            // return this.patient.provinceId
        },
    },
    async created() {
        const genderApi = api('patient/gender')
        this.genderList = await genderApi.get()
        const religionApi = api('patient/religion')
        this.religionList = await religionApi.get()

        if(this.$route.query.id !== undefined) {
            const patientApi = api('patient/detail')

            const patientResult = await patientApi.getWithParams(this.$route.query.id)
            this.patient = patientResult[0]
            this.patientMedicalRecordId = patientResult[1]
            this.patientOrthoSpaceId = patientResult[2]
            this.patientOrthoDiagnoseId = patientResult[3]
            this.role = patientResult[4]
        }
    },
    methods: {
        async save() {
            const patientApi = api('patient')
            if(this.$route.query.id !== undefined) {
                await patientApi.update(this.patient, this.$route.query.id)
            } else {
                await patientApi.create(this.patient)
            }
            this.$router.push({ name: 'patient' })
        },
        cancel() {
            this.$router.push({ name: 'patient' })
        },
        medicalHistory() {
            this.$router.push({
                name: 'medicalRecordDetail',
                query: {
                    id: this.patientMedicalRecordId
                }
            })
        },
        orthoSpace() {
            this.$router.push({
                name: 'patientOrthoSpaceDetail',
                query: {
                    id: this.patientOrthoSpaceId
                }
            })
        },
        orthoDiagnose() {
            this.$router.push({
                name: 'patientOrthoDiagnoseDetail',
                query: {
                    id: this.patientOrthoDiagnoseId
                }
            })
        },
        finishLookup(data) {
            const currentPatient = this.patient
            this.patient = {
                ...currentPatient,
                ...data
            }
        },
        selectChange(data) {
            const currentPatient = this.patient
            this.patient = {
                ...currentPatient,
                ...data
            }
        },
    }
}
</script>